export default __webpack_public_path__ + "static/media/avatar.66e63491.png";